module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(" " + _vm._s(_vm.data.type) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: {
      'break-word': _vm.data.price == '￥399'
    }
  }, [_vm._v(" " + _vm._s(_vm.data.price))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.data.info) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_vm._v(" 购票 ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50ae964f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketItem.vue
// module id = 56
// module chunks = 0